// extracted by mini-css-extract-plugin
module.exports = {"w1cefnex":"w1cefnex"};